<template>
    <div class="w-full bg-white border-t">
        <div class="flex text-xs font-bold h-navbar">
            <div v-on:click="navigate('/dashboard')" class="flex-1 text-center h-navbar">
                <div v-if="$route.name == 'dashboard-page'">
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_home.svg" /></div>
                    <div class="text-primary" v-text="lang('lbl_0000083')"></div>
                </div>
                <div v-else>
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_home_dark.svg" /></div>
                    <div v-text="lang('lbl_0000083')"></div>
                </div>
            </div>
            <div v-on:click="navigate('/profile')" class="flex-1 text-center h-navbar">
                <div v-if="$route.name == 'profile-page'">
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_avatar.svg" /></div>
                    <div class="text-primary" v-text="lang('lbl_0000084')"></div>
                </div>
                <div v-else>
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_avatar_dark.svg" /></div>
                    <div v-text="lang('lbl_0000084')"></div>
                </div>
            </div>
            <div v-on:click="navigate('/services')" class="flex-1 text-center h-navbar">
                <div v-if="isServicesPage()">
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_services.svg" /></div>
                    <div class="text-primary" v-text="lang('lbl_0000296')"></div>
                </div>
                <div v-else>
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_services_grey.svg" /></div>
                    <div v-text="lang('lbl_0000296')"></div>
                </div>
            </div>
            <div v-on:click="navigate('/settings')" class="flex-1 text-center h-navbar">
                <div v-if="isSettingPage()">
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_settings.svg" /></div>
                    <div class="text-primary" v-text="lang('lbl_0000085')"></div>
                </div>
                <div v-else>
                    <div><img class="w-icon h-icon mx-auto mt-2" src="@/assets/icons/papsi_settings_dark.svg" /></div>
                    <div v-text="lang('lbl_0000085')"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixin from './../../mixin.js';

export default {
    mixins: [
        mixin,
    ],
    data() {
        return {
            settings_pages: [
                'settings-page',
                'password-setting-page',
                'username-setting-page',
                'mobile-setting-page',
                'email-setting-page',
                'deactivate-account-page',
                'deactivate-account-verify-page',
                'deactivate-account-final-page',
                'auth-security-page',
                'settings-info-page',
                'update-tin-info-page',
                'update-security-pin-page',
                'login-history-page',
                'update-date-of-birth-info-page',
            ],
            services_pages: [
                'services-page',
                'eft-page',
            ],
        }
    },
    methods: {
        isSettingPage() {
            return this.settings_pages.indexOf(this.$route.name) !== -1;
        },
        isServicesPage() {
            return this.services_pages.indexOf(this.$route.name) !== -1;
        },
        navigate(path) {
            this.$router.push(path);
        },
    }
}
</script>
